import { stampFeatures } from '@/mocks/playgroundData';
import BioStampCard from '@/components/feature/BioStampCard';
import { useInView } from '@/hooks/useInView';

export default function BioStampSection() {
  const [ref, inView] = useInView<HTMLDivElement>();

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <div ref={ref} className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        {/* Left: text + card */}
        <div
          className={`transition-all duration-700 ${
            inView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-5'
          }`}
        >
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-100 rounded-full mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
            <span className="text-xs font-medium text-accent-700 uppercase tracking-wider">The bioStamp</span>
          </div>
          <h2
            className="text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-3"
            style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}
          >
            The bioStamp
          </h2>
          <p className="text-lg font-medium text-primary-700 mb-4">More than a QR code.</p>
          <p className="text-base text-foreground-600 leading-relaxed mb-7 max-w-xl">
            A bioStamp is a biometrically authenticated digital identity stamp containing
            cryptographically protected verification information. It enables compatible applications
            to check the registered sender and the integrity of protected message information.
          </p>

          <div className="rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-7">
            <BioStampCard />
          </div>
        </div>

        {/* Right: features */}
        <div
          className={`space-y-6 transition-all duration-700 ${
            inView ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-5'
          }`}
          style={{ transitionDelay: '120ms' }}
        >
          {stampFeatures.map((item) => (
            <div
              key={item.id}
              className="flex items-start gap-4 p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300/60 transition-colors"
            >
              <div className="w-11 h-11 shrink-0 flex items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                <i className={`${item.icon} text-xl`} />
              </div>
              <div>
                <h3 className="text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}